'use client'

// Watches which section is behind the navbar. Returns true when any of
// the listed section IDs is the dominant element at the top of the
// viewport (accounting for navbar height).

import { useEffect, useState } from 'react'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { gsapSetup } from '@/lib/animations/gsapSetup'

export function useDarkSection(sectionIds: string[], navHeight = 80) {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    gsapSetup()
    const triggers: ScrollTrigger[] = []
    let activeCount = 0

    sectionIds.forEach(id => {
      const el = document.getElementById(id)
      if (!el) return

      const enter = () => {
        activeCount++
        setIsDark(true)
      }
      const leave = () => {
        activeCount = Math.max(0, activeCount - 1)
        if (activeCount === 0) setIsDark(false)
      }

      triggers.push(
        ScrollTrigger.create({
          trigger: el,
          start: `top top+=${navHeight}`,
          end:   `bottom top+=${navHeight}`,
          onEnter:     enter,
          onEnterBack: enter,
          onLeave:     leave,
          onLeaveBack: leave,
        }),
      )
    })

    ScrollTrigger.refresh()
    return () => { triggers.forEach(t => t.kill()) }
  }, [sectionIds, navHeight])

  return isDark
}
